import { InstanceAuditPanel } from "@/components/instance/panels/Audit";
import { AccessPanel } from "@/components/instance/panels/Access";
import { EventsPanel } from "@/components/instance/panels/Events";
import { InstanceSecurityPanel } from "@/components/instance/panels/Security";
import { InstanceDataPanel } from "@/components/instance/panels/Data";
import { InstanceDetailPanel } from "@/components/instance/panels/Detail";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { useResourceContext } from "@/layouts/ResourceContext";
import {
  DeleteOutlined,
  DownOutlined,
  PlayCircleOutlined,
  PlusCircleOutlined,
  ReloadOutlined,
  SettingOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Button, Modal, Dropdown, Space, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdate, useInvalidate } from "@refinedev/core";
import { RESOURCE_TYPE_POOLS } from "./pools";
import { InstanceTopologyPanel } from "@/components/instance/panels/Topology";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useResourceDelete } from "@/hooks/useResourceDelete";
import { useCan } from "@refinedev/core";
import { MonitoringPanel } from "@/components/instance/panels/Monitoring";

const RESOURCE = RESOURCE_TYPE_POOLS;

export const PoolsDetailTabs = () => {
  let tabs = [
    {
      key: "details",
      label: "Details",
      children: <InstanceDetailPanel resource={RESOURCE} />,
    },
    { key: "audit", label: "Audit", children: <InstanceAuditPanel /> },
    { key: "security", label: "Security", children: <InstanceSecurityPanel /> },
    { key: "topology", label: "Topology", children: <InstanceTopologyPanel /> },
    { key: "data", label: "Data", children: <InstanceDataPanel /> },
    { key: "monitoring", label: "Monitoring", children: <MonitoringPanel mode={"pool"}/>},
  ]
  //const { data: allowAccess } = useCan({action:"access", resource:"pools"});
  //if(allowAccess && allowAccess.can){
    tabs.push({ key: "access", label: "Access", children: <AccessPanel />});
    tabs.push({ key: "events", label: "Events", children: <EventsPanel type="pool"/>});
  //}
  return tabs;
};

export const PoolsActions = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useResourceContext();
  const navigate = useResourceNavigate();
  const invalidate = useInvalidate();
  const [selectedInstance] = state.selectedResources;

  const navigateToCreation = () => {
    navigate({ resource: RESOURCE, action: "create" });
  };
  const { mutateAsync: deleteMutate } = useResourceDelete();
  const { mutate, isLoading: isUpdating } = useUpdate({
    successNotification: (response, { id, values }, resource) => {
      const { action, data } = values;
      return {
        message: t(`pools.actionResult.${action}.success`, { id }),
        description: "Success",
        type: "success",
      };
    },
  });

  const lifecycleMenu = [
    {
      key: "start",
      label: (
        <span>
          <PlayCircleOutlined /> {t("actions.start")}
        </span>
      ),
    },
    {
      key: "stop",
      label: (
        <span>
          <StopOutlined /> {t("actions.stop")}
        </span>
      ),
    },
    {
      key: "delete",
      label: (
        <span>
          <DeleteOutlined /> {t("actions.delete")}
        </span>
      ),
    },
  ];
  const actionsMenu = [
    { key: "details", label: t("pools.menu.details") },
    {
      key: "settings",
      label: t("pools.menu.settings"),
      type: "group",
      icon: <SettingOutlined />,
      children: [
        {
          key: "changeHadoop",
          label: "Change Hadoop",
          disabled: !selectedInstance || selectedInstance.type !== "hadoop",
        },
        {
          key: "changeMySQL",
          label: "Change MySQL",
          disabled: !selectedInstance || selectedInstance.type !== "mysql",
        },
        { key: "changeCapacity", label: "Change Capacity" },
      ],
    },
  ];

  const onClickLifecycle = (item) => {
    const [selectedPool] = state.selectedResources;
    console.log("Lifecycle:", selectedPool.id, item.key);
    if (item.key === "delete") {
      deleteMutate({
        resource: RESOURCE,
        id: selectedInstance.id,
      });
    } else {
      mutate({
        resource: "pools",
        id: selectedInstance.id,
        values: {
          action: item.key,
        },
      });
    }
  };
  const onClickAction = (item) => {
    const [selectedInstance] = state.selectedResources;
    console.log("Action:", selectedInstance.id, item.key);
    navigate({
      resource: RESOURCE,
      action: item.key,
      key: selectedInstance.id,
    });
  };

  const launchMenu = [
    { key: "hadoop", label: "Launch Hadoop cluster" },
    { key: "mysql", label: "Launch MySQL cluster" },
  ];

  const onClickLaunch = (item) => {
    navigate(
      { resource: RESOURCE, action: "create" },
      { state: { key: item.key, resource: RESOURCE } },
    );
  };

  const buttons = [
    <Dropdown
      key="state"
      menu={{ items: lifecycleMenu, onClick: onClickLifecycle }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("pools.menu.state", "Pool State")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    <Dropdown
      key="action"
      menu={{ items: actionsMenu, onClick: onClickAction }}
      placement="bottom"
      arrow
    >
      <Button>
        <Space>
          {t("pools.menu.actions", "Actions")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,
    /*
    <Button
      key="launch"
      icon={<PlusCircleOutlined />}
      onClick={navigateToCreation}
    >
      {t("pools.menu.launch")}
    </Button>,*/

    <Dropdown
      menu={{ items: launchMenu, onClick: onClickLaunch }}
      placement="bottom"
      arrow
    >
      <Button icon={<PlusCircleOutlined />}>
        <Space>
          {t("pool.menu.launch", "Launch Pool")}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>,

    <RefreshButton
      key="refresh"
      onClick={() => {
        invalidate({
          resource: RESOURCE,
          invalidates: ["list"],
        });
      }}
    />,
  ];
  return <Space>{buttons}</Space>;
};
